import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const LobbySvg = () => (
  <svg width="23" height="23" viewBox="0 0 23 23" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.4699 1.27148L5.05322 3.10482L5.96989 4.93815V5.85482C5.96989 6.24348 6.33472 6.60281 6.95256 6.89981C6.83851 7.55854 6.86977 8.23422
      7.04415 8.8796C7.21852 9.52498 7.53181 10.1245 7.96208 10.6361C8.39236 11.1478 8.92923 11.5592 9.53514 11.8417C10.1411 12.1242 10.8014 12.2709
      11.4699 12.2715C12.1384 12.2709 12.7987 12.1242 13.4046 11.8417C14.0105 11.5592 14.5474 11.1478 14.9777 10.6361C15.408 10.1245 15.7213 9.52498
      15.8956 8.8796C16.07 8.23422 16.1013 7.55854 15.9872 6.89981C16.6051 6.60281 16.9699 6.24348 16.9699 5.85482V4.93815L17.8866 3.10482L11.4699
      1.27148ZM9.63656 3.10482H13.3032V4.93815L11.4699 5.85482L9.63656 4.93815V3.10482ZM11.4699 10.4381C9.95372 10.4381 8.71989 9.20431 8.71989 7.68815C8.71989
      7.60931 8.73731 7.5259 8.74372 7.44523C9.54764 7.59831 10.4771 7.68815 11.4699 7.68815C12.4626 7.68815 13.3921 7.59831 14.1961 7.44523C14.2025 7.5259 14.2199
      7.60931 14.2199 7.68815C14.2199 9.20431 12.9861 10.4381 11.4699 10.4381Z"
      fill="currentColor"
    />
    <path
      d="M11.4696 13.188C7.15206 13.188 4.13623 15.4494 4.13623 18.688V20.5213H18.8029V18.688C18.8029 15.4494 15.7871 13.188 11.4696 13.188ZM11.4696
      19.6046C11.2264 19.6046 10.9933 19.5081 10.8214 19.3362C10.6495 19.1643 10.5529 18.9311 10.5529 18.688C10.5529 18.4449 10.6495 18.2117 10.8214 18.0398C10.9933
      17.8679 11.2264 17.7713 11.4696 17.7713C11.7127 17.7713 11.9458 17.8679 12.1177 18.0398C12.2897 18.2117 12.3862 18.4449 12.3862 18.688C12.3862 18.9311 12.2897
      19.1643 12.1177 19.3362C11.9458 19.5081 11.7127 19.6046 11.4696 19.6046ZM11.4696 16.8547C11.2264 16.8547 10.9933 16.7581 10.8214 16.5862C10.6495 16.4143 10.5529
      16.1811 10.5529 15.938C10.5529 15.6949 10.6495 15.4617 10.8214 15.2898C10.9933 15.1179 11.2264 15.0213 11.4696 15.0213C11.7127 15.0213 11.9458 15.1179 12.1177
      15.2898C12.2897 15.4617 12.3862 15.6949 12.3862 15.938C12.3862 16.1811 12.2897 16.4143 12.1177 16.5862C11.9458 16.7581 11.7127 16.8547 11.4696 16.8547Z"
      fill="currentColor"
    />
  </svg>
);

const Lobby = (props: IIconProps) => <Icon component={LobbySvg} {...props} />;

export default Lobby;
